export default __webpack_public_path__ + "static/payment-2-66bcc856fa94c4309f15c6ec1cce58a3.png";